import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { PrivacyLevel } from '@vendasta/meeting-analysis';
import { MatSelectModule } from '@angular/material/select';
import { take } from 'rxjs';
import { MeetingListService } from '../../meeting-list.service';
import { MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$ } from '@galaxy/meeting-analysis/static';

interface DialogData {
  namespace: string;
  privacyLevel: PrivacyLevel;
  conversationId: string;
}

@Component({
  templateUrl: './change-visibility-dialog.component.html',
  styleUrls: ['./change-visibility-dialog.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    GalaxyAlertModule,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    GalaxyFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class ChangeVisibilityDialogComponent {
  changingPrivacyLevel = false;
  meetingListService = inject(MeetingListService);
  namespaceName$ = inject(MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$);
  protected readonly PrivacyLevel = PrivacyLevel;
  selectedPrivacyLevel: PrivacyLevel;
  namespace = '';

  constructor(
    public dialogRef: MatDialogRef<ChangeVisibilityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    protected readonly snackbarService: SnackbarService,
  ) {
    this.selectedPrivacyLevel = data.privacyLevel;
    this.namespace = data.namespace;
  }

  savePrivacyLevel() {
    this.changingPrivacyLevel = true;
    this.meetingListService
      .updateConversationVisibility(this.data.conversationId, this.data.namespace, this.selectedPrivacyLevel)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.snackbarService.openSuccessSnack('VISIBILITY.SUCCESS_CHANGING');
          this.dialogRef.close(true);
        },
        error: () => {
          this.snackbarService.openErrorSnack('VISIBILITY.ERROR_CHANGING');
          this.changingPrivacyLevel = false;
        },
      });
  }
}
